import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie';
import {
		messageCount
	} from "@/api/api.js"
Vue.use(Vuex)
var lifeData = {
	userInfo: {},
	accessToken: '',
	isLogin: false
};
let obj={
	userInfo: {},
	accessToken: '',
	isLogin: false
};
//localStorage.setItem('accessToken',res.access_token);
//localStorage.getItem('accessToken',res.access_token);
//localStorage.clear()
//sessionStorage.setItem("lifeData", '');
try {
	// 尝试获取本地是否存在lifeData变量，第一次启动APP时是不存在的
	lifeData = localStorage.getItem('lifeData') ? JSON.parse(localStorage.getItem('lifeData')) : {
		userInfo: {},
		accessToken: '',
		refreshToken:'',
		isLogin: false
	};
} catch (e) {

}

// 需要永久存储，且下次APP启动需要取出的，在state中的变量名
let saveStateKeys = ['userInfo', 'accessToken', 'isLogin', 'refreshToken'];

// 保存变量到本地存储中
const saveLifeData = function(key, value) {
	// 判断变量名是否在需要存储的数组中

	if (saveStateKeys.indexOf(key) != -1) {
		console.log(localStorage.getItem('lifeData'))
		// 获取本地存储的lifeData对象，将变量添加到对象中
		let tmp =localStorage.getItem('lifeData')?JSON.parse(localStorage.getItem('lifeData')):obj;
		
		// 第一次打开APP，不存在lifeData变量，故放一个{}空对象
		
		tmp[key] = value;
		// 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
		localStorage.setItem(key, JSON.stringify(value));
		localStorage.setItem('lifeData', JSON.stringify(tmp));
	}

	/*if(key == 'refreshToken') {
		uni.setStorageSync('token', {
			content: value,
			datetime: new Date().getTime()
		})
	}*/
}
export default new Vuex.Store({
	state: {
		userInfo: lifeData.userInfo ? lifeData.userInfo : {},
		accessToken: lifeData.accessToken ? lifeData.accessToken : '',
		refreshToken:lifeData.refreshToken ? lifeData.refreshToken : '',
		isLogin: lifeData.isLogin ? lifeData.isLogin : false,
		hasAlert: false,
		defaultAvatar:require('@/assets/mine/default_avatar.png'),
		totalNewsNum:0
	},
	mutations: {
		setLogin(state, isLogin) {
			state.isLogin = isLogin
			if(isLogin){
				state.hasAlert = false
			}
		},
		$uStore(state, payload) {
			// 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
			let nameArr = payload.name.split('.');
			let saveKey = '';
			let len = nameArr.length;
			if (nameArr.length >= 2) {
				let obj = state[nameArr[0]];
				for (let i = 1; i < len - 1; i++) {
					obj = obj[nameArr[i]];
				}
				obj[nameArr[len - 1]] = payload.value;
				saveKey = nameArr[0];
			} else {
				// 单层级变量，在state就是一个普通变量的情况
				state[payload.name] = payload.value;
				saveKey = payload.name;
				//debugger
			}
			// 保存变量到本地，见顶部函数定义
			saveLifeData(saveKey, state[saveKey])

		},
		refreshTotalNewsNum(state,num){
			state.totalNewsNum = num;
		}
	},
	actions: {
		getTotalNewsNum(context){
			messageCount({status:0,platform:2}).then(res=>{
				context.commit('refreshTotalNewsNum',res)
			})
		}
	},
	modules: {

	}
})
